(function ($) {
	$.fn.lmRailSlider = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}

		// Default settings are set here
		var settings = $.extend({
			nextButton: '.sponsor-slider__next',
			prevButton: '.sponsor-slider__prev',
			selector: '.slider',
			slideTimer: 4000,
			dots: true,
		}, options);
		
		// These are all the methods available for the plugin
		var methods = {};

		methods.initContext = function($context) {
			var $track = $context.find(settings.selector);
			$track.slick({
				arrows: true,
				nextArrow: settings.nextButton,
				prevArrow: settings.prevButton,
				autoplay: settings.autoplay,
				slidesToShow: 1,
				dots: settings.dots,
				infinite: false,
				adaptiveHeight: true,
			});

			$context.data('initialized', true);
		}
		
		// Filter each function
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}
		
		// Methods to run inside loop
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);
			// NOTE: Method you'd like initialized on a per context basis
			methods.initContext($this);
		});
};

}(jQuery));
